import React, { useCallback, useState } from "react";

import useMailboxCanSend from "../hooks/useMailboxCanSend";
import ComposeEmailDialog from "./ComposeEmailDialog";

/** { to, cc, bcc, subject, body } from a mailto: href. */
export function parseMailto(href) {
  const [addr, query = ""] = href.replace(/^mailto:/i, "").split("?");
  const params = new URLSearchParams(query);
  return {
    to: decodeURIComponent(addr || ""),
    cc: params.get("cc") || "",
    bcc: params.get("bcc") || "",
    subject: params.get("subject") || "",
    body: params.get("body") || "",
  };
}

/**
 * Opens the CRM's own composer for email links inside it, for agents who have
 * connected Gmail. Everyone else, and any modified click (new window, etc.),
 * keeps the normal mailto: link to their own mail app. Wraps whole pages so
 * their many email links need no changes of their own.
 */
export default function MailtoComposerScope({ children }) {
  const canSend = useMailboxCanSend();
  const [draft, setDraft] = useState(null);

  const onClickCapture = useCallback((e) => {
    if (!canSend || e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const link = e.target.closest?.('a[href^="mailto:"]');
    if (!link) return;
    const parsed = parseMailto(link.getAttribute("href"));
    if (!parsed.to) return;
    e.preventDefault();
    setDraft(parsed);
  }, [canSend]);

  return (
    <div style={{ display: "contents" }} onClickCapture={onClickCapture}>
      {children}
      <ComposeEmailDialog open={Boolean(draft)} initial={draft} onClose={() => setDraft(null)} />
    </div>
  );
}
